// extracted by mini-css-extract-plugin
module.exports = {"arContainer":"styles_arContainer__26rv3","resultsElement":"styles_resultsElement__221b7","bottomArea":"styles_bottomArea__3EbGq"};